import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PageHero from "../../components/motion/PageHero";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

function PendingApproval() {
    const navigate = useNavigate();
    const language = localStorage.getItem('language');
    const isAr = language === 'ar';

    return (
        <Box className="w-full min-h-[70vh] flex flex-col items-center justify-center px-4">
            <PageHero
                title={isAr ? 'حسابك بانتظار الموافقة' : 'Account pending approval'}
                subtitle={isAr
                    ? 'تم استلام طلب التسجيل. سيتم إشعارك عند تفعيل حسابك من قبل الإدارة.'
                    : 'Your registration was received. You will be notified once an admin activates your account.'}
                icon={<HourglassEmptyIcon />}
            />
            <Button variant="outlined" onClick={() => {
                localStorage.removeItem('token');
                navigate('/login');
            }}>
                {isAr ? 'تسجيل الخروج' : 'Log out'}
            </Button>
        </Box>
    );
}

export default PendingApproval;
